import React, {useState, useEffect} from 'react';
import {connect} from 'react-redux';
import SaleFooter from '../SaleFooter/SaleFooter';
import PopUp from '../../../Shared/Popup/PopUp';
import BtnSubmit from '../../../Shared/Buttons/BtnSubmit';
import PopUpWhatIsEsim from '../Esim/PopUpWhatIsEsim';
import {prepareNewWindowUrl} from '../../../../utilities/StringHelpers/StringHelpers.js';
import {
  goToPage,
  reportAnalytics,
  setPremiumPackageChanged,
  setProductVasChanged,
  setProductVasPopupChanged,
  setVasPopupChanged,
  displayProductVas,
  selectProductVas,
  setIsRegularSimClicked,
  setIsEsimClicked,
  markAsEsimProduct,
  updateSimPrices,
  markAsSimProduct,
} from '../saleBlockSlice';

const ChooseTypeSIM = (props) => {
  const [isShowPopUp, setPopUp] = useState(false);
  const [chooseOneTypeSim, setChooseOneTypeSim] = useState(false);
  let flowType = props.flowType;
  let esimPriceOneTime = props.esim.isEsimClicked ? parseFloat(props.esim.esimData?.esimPrice?.value) : 0;
  let simPriceOneTime = props.productsInfo.selectedProducts[props.productsInfo.selectedProducts.length - 1]?.oneTimeFee;

  useEffect(() => {
    if (typeof window.scrollTo === 'function') {
      window.scrollTo(0, 0);
    }
    setChooseOneTypeSim(true);
    props.updateSimPrices({
      esimPrice: props.esim.esimData?.esimPrice?.value,
      simPrice: props.productsInfo.selectedProducts[props.productsInfo.selectedProducts.length - 1].oneTimeFee,
    });
  }, []);

  const handleExtraProductsPageContinue = async () => {
    let filteredVasList = props.productsInfo.baseProduct.vasList?.filter((x) => !x.isVirtualSoc);
    const hasVasList = filteredVasList != null && filteredVasList.length > 0;
    const nextPage = getNextPage(hasVasList);

    if (flowType == 'existsCustomer') {
      await props.goToPage({page: nextPage, percent: 32});
    } else {
      await props.goToPage({page: nextPage, percent: 22});
    }
    props.reportAnalytics({
      eventCategory: 'sim_esim_process',
      eventAction: props.esim.isEsimClicked ? 'eSim' : 'SIM רגיל',
      eventLabel: 'סוג SIM',
    });

    if (props.esim.isEsimClicked) {
      props.markAsEsimProduct();
    } else {
      props.markAsSimProduct();
    }
  };

  const getNextPage = (hasVasList) => {
    let nextPage = '';
    if (hasVasList) {
      nextPage = 'extraPage';
    } else {
      nextPage = 'newNumberPage';
    }
    return nextPage;
  };

  //page params
  let isDisplayFooter = true;
  let btnText = 'אפשר להתקדם';
  let totalPrice = props.totalPrice;
  let totalPriceOneTime = props.totalPriceOneTime;
  let priceText = 'לחודש';
  let formid = 'sale';
  let currentPageFunction = handleExtraProductsPageContinue;
  const disabled = !(props.esim.isRegularSimClicked || props.esim.isEsimClicked);

  let mainTitle = '';
  let secondTitle = '';

  mainTitle = 'איזה סוג SIM תרצו?';
  secondTitle = 'SIM רגיל או eSIM דיגיטלי למכשירים תומכים';

  const Price = (props) => {
    if (props.price == '' || props.price == '0') {
      return <div className='included'>ללא עלות</div>;
    } else {
      return (
        <>
          <div className='price'>
            ₪{props.price} {props.priceText && props.priceText != '' && <div className='period-time'>{props.priceText}</div>}
          </div>
        </>
      );
    }
  };

  const handleOptionChange = (val) => {
    setChooseOneTypeSim(true);
    if (val) {
      props.setIsRegularSimClicked(true);
      props.setIsEsimClicked(false);
    } else {
      props.setIsRegularSimClicked(false);
      props.setIsEsimClicked(true);
    }
  };

  const checkStatusChoose = () => {
    if (disabled) {
      setChooseOneTypeSim(false);
    } else {
      setChooseOneTypeSim(true);
    }
  };

  let currentPageHeadline = (
    <div className='page-headline-wrapper'>
      <h1 className='sale-title-big'> {mainTitle} </h1>
      <h2 className='sale-title-small'> {secondTitle} </h2>
      <div role='button' tabIndex='0' className='vas-selection-wrapper' onClick={() => handleOptionChange(true)}>
        <div className={`vas-choose-type-esim ${props.esim.isRegularSimClicked ? 'selected' : ''}`}>
          <div className='title-wrapper'>
            <div className='short-description'>
              <label>אני רוצה כרטיס SIM רגיל</label>
            </div>
          </div>
          <div className='price-wrapper'>
            <Price price={props.esim.simPrice} priceText={props.esim.simPrice > 0 ? 'עלות חד פעמית' : 'ללא עלות'} />
          </div>
        </div>
      </div>

      <div className='vas-selection-wrapper-main-container'>
        <div role='button' tabIndex='1' className='vas-selection-wrapper' onClick={() => handleOptionChange(false)}>
          <div className={`vas-choose-type-esim ${props.esim.isEsimClicked ? 'selected' : ''}`}>
            <div className='title-wrapper'>
              <div className='short-description'>
                <label>אני רוצה eSIM</label>
              </div>
            </div>
            <div className='price-wrapper'>
              <Price price={props.esim.eSimPrice} priceText={props.esim.eSimPrice > 0 ? 'עלות חד פעמית' : 'ללא עלות'} />
            </div>
          </div>
        </div>
        <p className='vas-selection-wrapper-main-container-text'>{props.esim?.esimData?.esimSupportText?.value}</p>
      </div>

      <div className='title-wrapper'>
        <h2 className='sale-title-small-what-is-esim'>
          <a onClick={() => setPopUp(true)}>מה זה eSIM?</a>
        </h2>
        <h2 className='sale-title-small-support-devices'>
          <a onClick={() => prepareNewWindowUrl(props.esim?.esimData?.cellularDevicesSupportedUrl?.value, props.context)}>
            האם המכשיר שלי תומך ב-eSIM?
          </a>
        </h2>
      </div>
      {!chooseOneTypeSim ? (
        <div className='short-description-choose-one-option-esim'>
          <label>יש לבחור באחת האפשרויות</label>
        </div>
      ) : null}

      <PopUp preventWrapperClose={true} showPopUp={isShowPopUp} onClose={() => setPopUp(false)} className='what-is-esim-popup'>
        <PopUpWhatIsEsim
          iContent={props.esim.esimData}
          props={props}
          isPopUp={true}
          footerButton={<BtnSubmit onclick={() => setPopUp(false)} text='סגור' />}
        />
      </PopUp>
    </div>
  );

  return (
    <div className='slideAnimation'>
      <div className='sale-page-content width-664'>
        {currentPageHeadline}
        <SaleFooter
          isDisplayFooter={isDisplayFooter}
          isEsimFooter={true}
          btnText={btnText}
          onclick={disabled ? checkStatusChoose : currentPageFunction}
          price={totalPrice}
          totalPriceOneTime={props.esim.isEsimClicked ? totalPriceOneTime + esimPriceOneTime : totalPriceOneTime + simPriceOneTime}
          priceText={priceText}
          formid={formid}
        />
      </div>
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    saleType: state.saleBlock.saleType,
    flowType: state.saleBlock.flowType,
    page: state.saleBlock.page,
    percent: state.saleBlock.percent,
    progressBarPoints: state.saleBlock.progressBarPoints,
    configuration: state.saleBlock.epiServer.configuration,
    totalPrice: state.saleBlock.totalPrice,
    totalPriceOneTime: state.saleBlock.totalPriceOneTime,
    premiumPackages: state.saleBlock.premiumPackages,
    selectedVasList: state.saleBlock.selectedVasList,
    productsInfo: state.saleBlock.productsInfo,
    esim: state.saleBlock.esim,
  };
};

const mapDispatchToProps = {
  goToPage,
  reportAnalytics,
  setPremiumPackageChanged,
  setProductVasChanged,
  setProductVasPopupChanged,
  setVasPopupChanged,
  displayProductVas,
  selectProductVas,
  setIsRegularSimClicked,
  setIsEsimClicked,
  markAsEsimProduct,
  updateSimPrices,
  markAsSimProduct,
};

export default connect(mapStateToProps, mapDispatchToProps)(ChooseTypeSIM);
